import React from "react";
import ReactDOM from "react-dom";
import ridescout from "./ridescout.png";
import design from "./design.png";
import weathermatic from "./weathermatic.png";
import daa from "./daa.png";
import variantdriver from "./variantdriver.png";
import rythmpad from "./rythmpad.png";
import ar from "./ar.png";

const text =
  "Walmart Inc. is an American multinational retail corporation that operates a chain of hypermarkets, discount department stores, and grocery stores from the United States, headquartered in Bentonville, Arkansas.";
const ridescoutText =
  "Aggregator For Ride Shares. Created startup application and design in 2011. Was acquired by Daimler. We contributed to the UX Design, Project Management, and Software Engineering (iOS).";
const designText =
  "Sartaj Chowdhury examines the radical nature of critically acclaimed products that actively attempt to influence the behavior of power users, and how this mentality can be applied to many sectors of product design.";
const rythmText =
  "The pad's radical design encourages immersive multi-hit motions with pressure sensitive sensors, making it a perfect digital instrument for rhythm. Get a prebuilt rhythm pad, or have it custom made just for you. Feel Analog, Play Digital, Perform Live.";
const weatherText =
  "We created the concept, design and application using the framework, ReactNative. Using proven irrigation science and market leading technology, we helped to maximize landscape beauty while saving billions of gallons of water. We think you will find that his application is among the most innovative in the industry and will help customers fulfill their irrigation water management and savings needs.";
const daaText =
  "We built this prototype to aggregate and present combinational drug effect data, since drug reactions are a significant problem in healthcare and these side effects are often reported after the drug is released to market.";
const variantdriverText =
  "The Variant Driver mobile application can be considered an 'Uber for commercial freight drivers', helping drivers find and transport loads all over the United States. The app's requirements included: creating the routes, providing management of different loads, managing times to go home, ability to chat with other drivers and freight people, and notifications for updates.";

const Work = () => {
  return (
    <div className="workcontainer">
      <div className="maxwidthcontainer">
        <a href="/">
          <img className="logo" src="./assets/images/mayu_logo.svg" />
        </a>

        <div className="h1">Our Work</div>

        <WorkItem title="Rhythm Pad" subtitle={rythmText} image={rythmpad} />
        <WorkItem
          title="RideScout"
          subtitle={ridescoutText}
          image={ridescout}
        />
        <WorkItem
          title="The Audacity to Influence Through Design"
          subtitle={designText}
          image={design}
        />
        <WorkItem
          title="Weathermatic by Smartlink"
          subtitle={weatherText}
          image={weathermatic}
        />
        <WorkItem
          title="Drug Effect Aggregator"
          subtitle={daaText}
          image={daa}
        />
        <WorkItem
          title="Variant Driver"
          subtitle={variantdriverText}
          image={variantdriver}
        />
        <WorkItem title="AR Filter(s)" subtitle={text} image={ar} />

        <div>
          <div className="h1footer">Come work with us.</div>
          <div className="footer">
            We do AR/VR/App interactive experiences.
            <br />
            <br />
            We specialize in React, Typescript, React Native, Frontend Testing
            Strategies, React Native, Electron, and Functional+Reactive
            Programming Paradigms.
            <br />
            <br />
            Contact us at contact@mayustudios.com.
          </div>
        </div>
      </div>
    </div>
  );
};

const WorkItem = (props) => {
  return (
    <div className="flex">
      <div className="clientName">
        {props.title}
        <div className="clientDesc">{props.subtitle}</div>
      </div>
      <div className="clientImage">
        <img src={props.image} />
      </div>
    </div>
  );
};

ReactDOM.render(<Work />, document.getElementById("app"));
